var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "en") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C49AB",
    d: "M0 16h23V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.55L7.643 8 11.5 6.26 0 1.066V4.55zm11.5 1.71L15.357 8 23 4.55V1.067L11.5 6.26zM0 11.45v3.483L11.5 9.74 7.643 8 0 11.45zm11.5-1.71L23 14.934V11.45L15.357 8 11.5 9.74z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625 0v5.333H0v5.334h8.625V16h5.75v-5.333H23V5.333h-8.625V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.775 0v6.4H0v3.2h9.775V16h3.45V9.6H23V6.4h-9.775V0h-3.45zm4.904 5.333h2.57L23 2.667V1.474l-8.32 3.86-.001-.001zM0 3.86l3.18 1.473h2.57L0 2.667V3.86zm17.25 6.807L23 13.333V12.14l-3.178-1.473H17.25zm-11.5 0L0 13.334v1.192l8.322-3.86H5.75v.001z",
    fill: "#C00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.5bc83d3503795bf4ed0265dd3427debb.svg";
export { ForwardRef as ReactComponent };